import { Directive, OnDestroy } from '@angular/core';
import { ReactiveDirective } from '@any2any/shared';
import { interval, merge, Observable, Subject, takeUntil } from 'rxjs';

@Directive()
export class IntervalDirective extends ReactiveDirective implements OnDestroy {

  private rxInterval?: Observable<number>;
  private stopSubject = new Subject<void>();

  public override ngOnDestroy() {
    super.ngOnDestroy();
    this.stopSubject.complete();
  }

  public get isIntervalRunning(): boolean {
    return !!this.rxInterval;
  }

  protected startInterval(ms: number): void {
    if (this.isIntervalRunning) {
      return;
    }
    this.rxInterval = interval(ms);
    this.rxInterval
      .pipe(
        takeUntil(merge(
          this.destroySubject,
          this.stopSubject
        ))
      )
      .subscribe((int: number) => {
        this.onTick(int);
      });
  }

  protected stopInterval(): void {
    if (!this.isIntervalRunning) {
      return;
    }
    this.stopSubject.next();
    delete this.rxInterval;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onTick(int: number) {
    // Override
  }

}
